export default {
  about: 'https://railmonsters.com/about',
  terms: 'https://railmonsters.com/terms',
  policy: 'https://railmonsters.com/rules',
  contact: 'https://railmonsters.com/contact#form',
};
